class AnalyticsService {
  constructor() {
    this.endpoint = 'https://your-lambda-function-url.amazonaws.com/analytics';
    this.userId = this.getUserId();
  }

  getUserId() {
    // Get user ID from license info or generate one
    const licenseInfo = localStorage.getItem('licenseInfo');
    if (licenseInfo) {
      const parsed = JSON.parse(licenseInfo);
      return parsed.customerId || parsed.email || 'anonymous';
    }
    return 'anonymous';
  }

  async trackEvent(eventType, data = {}) {
    const event = {
      userId: this.userId,
      eventType,
      timestamp: new Date().toISOString(),
      data: {
        ...data,
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language
      }
    };

    try {
      // Send to AWS Lambda
      const response = await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(event)
      });

      if (!response.ok) {
        console.error('Analytics tracking failed:', response.status);
      }
    } catch (error) {
      console.error('Analytics error:', error);
    }
  }

  // Track form usage
  trackFormUsage(formType) {
    this.trackEvent('form_usage', {
      formType,
      action: 'generate_prompt'
    });
  }

  // Track login
  trackLogin() {
    this.trackEvent('login', {
      licenseStatus: this.getLicenseStatus()
    });
  }

  // Track feature usage
  trackFeatureUsage(feature) {
    this.trackEvent('feature_usage', {
      feature
    });
  }

  getLicenseStatus() {
    const licenseInfo = localStorage.getItem('licenseInfo');
    if (licenseInfo) {
      const parsed = JSON.parse(licenseInfo);
      return parsed.isActive ? 'active' : 'inactive';
    }
    return 'unknown';
  }
}

export default new AnalyticsService(); 